<h1>Összes kutya</h1>

@if (fullDogList) {
  <app-missing-documents [dogs]="fullDogList"></app-missing-documents>
}

<app-doglist [fullDogList]="fullDogList"></app-doglist>
